import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import localForage from 'localforage';
import auth from './auth';
import {loader} from "@/plugins/stores/loader";
import {storeCache} from "@/plugins/stores/storeCache";
import {registrationOutbox} from "@/plugins/stores/registrationOutbox";
import { state, getters, actions, mutations } from '@/plugins/stores/appState';
import {createVuexBroadcastPlugin} from "@/plugins/vuexBroadcast";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
    storage: localForage, // or window.sessionStorage or localForage
    asyncStorage: true,
    //supportCircular: true,
})

export default new Vuex.Store({
    strict: true,
    state,
    getters,
    mutations,
    actions,
    modules: {
        auth,
        loader,
        registrationOutbox,
        storeCache,
    },
    plugins: [
      vuexLocalStorage.plugin,
      createVuexBroadcastPlugin('registrationOutbox'), // Sync 'registrationOutbox' store across browser tabs
    ],
});
